import React from "react";
import withStyles from "@material-ui/core/styles/withStyles";
import CustomText, { getFontSize, getFontWeight } from "../CustomText";
import "fontsource-muli";
import OutlinedInput from "@material-ui/core/OutlinedInput";
import Color from "../../../utils/Color";
import PopupState, { bindTrigger, bindPopover } from "material-ui-popup-state";
import Popover from "@material-ui/core/Popover";
import HelpOutlineIcon from "@material-ui/icons/HelpOutline";
import CustomPaper from "../../components/CustomPaper";
import IconButton from "@material-ui/core/IconButton";
import InfoIcon from "@material-ui/icons/Info";

const CustomTextInputV2 = ({
  classes,
  design,
  title,
  textstyle,
  startAdornment,
  endAdornment,
  onChange = () => {},
  value,
  type,
  placeholder,
  required,
  disabled = false,
  defaultValue,
  autoFocus = false,
  children,
  id = "outlined-input",
  fullWidth = false,
  multiline = false,
  errorMessage = "",
  errorTextStyle,
  notchedOutlineStyle,
  rootStyle,
  error = false,
  borderline = true,
  inputStyle,
  errorRequiredTextStyle,
  toolTip,
  toolTipText,
  toolTipText2,
  
  ...props
}) => {
  return (
    <div>
      {title ? (
        toolTip ? (
          <span>
            <CustomText
              className={`${classes.textStyle} ${textstyle}`}
              style={{ display: "inline-block" }}
            >
              {title}
            </CustomText>
            <PopupState variant="popover" style={{ display: "inline-block" }}>
              {(popupState) => (
                <span
                  style={{
                    margin: "0",
                    padding: "0",
                  }}
                >
                  <IconButton
                    //onClick={handleClick}
                    style={{
                      marginBottom: "0em",
                      padding: "0",
                      display: "inline",
                      marginTop: "-7px",
                      outline:"none"
                    }}
                    {...bindTrigger(popupState)}
                  >
                    <InfoIcon className={classes.infoIconStyle} />
                  </IconButton>

                  <Popover
                    {...bindPopover(popupState)}
                    anchorOrigin={{
                      vertical: "bottom",
                      horizontal: "center",
                    }}
                    transformOrigin={{
                      vertical: "top",
                      horizontal: "center",
                    }}
                  >
                    <CustomPaper
                      style={{
                        minWidth: "200px",
                        maxWidth: "200px",
                      }}
                    >
                      <CustomText
                        style={{
                          fontWeight: "300",
                        }}
                      >
                        {toolTipText}
                      </CustomText>
                      <CustomText
                        style={{
                          fontWeight: "300",
                          marginTop: 8,
                        }}
                      >
                        {toolTipText2}
                      </CustomText>
                    </CustomPaper>
                  </Popover>
                </span>
              )}
            </PopupState>
          </span>
        ) : (
          <CustomText
            className={`${classes.textStyle} ${textstyle}`}
            style={{ display: "inline-block" }}
          >
            {title}
          </CustomText>
        )
      ) : (
        false
      )}
      <OutlinedInput
        autoComplete="new-password"
        className={`${classes.root} ${design}`}
        id={id}
        value={value}
        onChange={onChange}
        type={type}
        startAdornment={startAdornment}
        endAdornment={endAdornment}
        placeholder={placeholder}
        required={required}
        disabled={disabled}
        defaultValue={defaultValue}
        autoFocus={autoFocus}
        fullWidth={fullWidth}
        multiline={multiline}
        error={error}
        classes={{
          root: !error
            ? `${classes.root}  ${rootStyle}`
            : `${classes.errorRoot}`,
          focused: classes.focused,
          notchedOutline: borderline
            ? `${classes.notchedOutline} ${notchedOutlineStyle}`
            : `${classes.notchedOutlineNone} ${notchedOutlineStyle}`,
          input: `${classes.inputStyle} ${inputStyle}`,
        }}
        {...props}
      />
      {error ? (
        <CustomText className={`${classes.errorTextStyle} ${errorTextStyle}`}>
          {errorMessage}
        </CustomText>
      ) : (
        false
      )}
      {required && error !== true ? (
        <CustomText
          className={`${classes.errorRequiredTextStyle} ${errorRequiredTextStyle}`}
        >
          *Required
        </CustomText>
      ) : (
        false
      )}
    </div>
  );
};

const styles = {
  root: {
    // marginBottom: 18,
    "& $notchedOutline": {
      borderWidth: 1,
    },
    "&:hover $notchedOutline": {
      border: "solid 2px #90a0b1",
      borderColor: "#90a0b1",
    },
    "&$focused $notchedOutline": {
      border: "solid 2px",
      borderColor: "#69a6f0",
    },
  },
  errorRoot: {
    // marginBottom: 0,

    "& $notchedOutline": {
      borderWidth: 1,
      border: "solid 2px #f46a6a",
      borderRadius: "5px",
    },
    "&:hover $notchedOutline": {
      border: "solid 1.9px #f46a6a",
      borderColor: Color.errorBorderColor,
    },
    "&$focused $notchedOutline": {
      border: "solid 1.9px #f46a6a",
      borderColor: Color.errorBorderColor,
    },
  },
  textStyle: {
    textTransform: "none",
    ...getFontWeight("600"),
    fontFamily: "Muli",
    fontSize: 15,
    marginBottom: 5,
    color: Color.primaryTextColor,
  },
  focused: {
    // borderRadius: "5px",
    // border: "solid 2px #69a6f0",
  },
  notchedOutline: {},
  notchedOutlineNone: {
    border: 0,
  },
  inputStyle: {
    textTransform: "none",
    ...getFontWeight("600"),
    fontFamily: "Muli",
    fontSize: 15,
    color: Color.primaryTextColor,
    paddingTop: 8,
    paddingBottom: 5,
    marginTop: 2,
  },
  errorTextStyle: {
    textTransform: "none",
    ...getFontWeight("normal"),
    fontFamily: "Muli",
    ...getFontSize("xxsmall"),
    color: Color.errorBorderColor,
  },
  errorRequiredTextStyle: {
    textTransform: "none",

    fontFamily: "Muli",
    fontSize: "12px",
    color: Color.primaryTextColor,
  },
  infoIconStyle: {
    //width: "17px",
    //height: "17px",
    alignSelf: "center",
    color: Color.secondaryTextColor,
    paddingLeft:5,
    outline:"none",
    cursor:"pointer"
  },
};
export default withStyles(styles)(CustomTextInputV2);
